import React, { useState } from "react";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import InMaVachTaiSan from "../../../containers/DanhSachTaiSan/InMaVachTaiSan";

export const BtnInMaVach = ({ item }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      <a href={() => false} onClick={handleShow}>
        <PopoversBootrap
          contentText="In mã vạch"
          trigger={["hover", "focus"]}
          placement={"top"}
        >
            <img src="/app-assets/images/icon-in-ma-vach-v3.png" />
        </PopoversBootrap>
      </a>
      {show && (
        <InMaVachTaiSan
          data={item}
          show={show}
          onHide={handleClose}
        ></InMaVachTaiSan>
      )}
    </>
  );
};
